export default {
  goalUsers: [],

  goalSchedules: [],

  goals: [],
  goal: {},
  goalDetail: {},
  goalId: null,
  goalCode: null,

  taskSubjects: [],
  taskSubject: {},
  taskSubjectCode: null,

  taskCategorys: [],
  taskCategory: {},
  taskCategoryCode: null,

  noteCategorys: [],
  noteCategory: {},
  noteCategoryCode: null,

  projectTypes: [],
  projectType: {},
  projectTypeCode: null,

  workDescriptions: [],
  workDescription: {},
  workDescriptionCode: null,


  noteSubjects: [],
  noteSubject: {},
  noteSubjectCode: null,

  requestTypes: [],
  requestType: {},
  requestTypeCode: null,

  callSubjects: [],
  callSubject: {},
  callSubjectCode: null,

  callCategories: [],
  callCategory: {},
  callCategoryCode: null,

  serviceSupportSubjects: [],
  serviceSupportSubject: {},
  serviceSupportSubjectCode: null,
  serviceSupports: [],
  serviceSupport: {},
  serviceSupportCode: null,
  contracts: [],
  contract: {},
  contractCode: null,
  setting: [],

  tasks: [],
  task: {},
  taskId: null,
  taskTimers: {},
  taskCode: null,
  taskNavigation: {},

  taskTeams: [],
  taskTeam: {},

  messages: [],
  message: {},
  messageCode: null,

  calls: [],
  call: {},
  callCode: null,

  requests: [],
  request: {},
  requestCode: null,

  notes: [],
  note: {},
  noteCode: null,

  meetings: [],
  meeting: {},
  meetingCode: null,
  meetingId: null,

  projects: [],
  project: {},
  projectId: null,
  projectCode: null,

  projectTeams: [],
  projectTeam: {},

  reminders: [],
};
